/** A45: строки формы отчёта — дословный порт разметки макета op-report-mock.html
 *  (классы opReport.module.css). Строка расчёта (0 → бейдж «подтвердит OO»),
 *  строка оплаты, пикер ачивок со сворачиванием «Ачивки · N из M». */
import { rub } from "./reportModel";
import m from "./opReport.module.css";

/** Открывалка NumPadPop у хоста (A27: числа — только кастомный нумпад). */
export type PadOpen = (anchor: HTMLElement, label: string, value: number, commit: (v: number) => void, opts?: { mode?: "money" | "int"; unit?: string; max?: number }) => void;

/* строка расчёта — в ритме строк оплаты (pm): мелкий uppercase-лейбл + пунктир.
   override → розовый, ooZero: 0 = отменено → оранжевый + бейдж */
export function CalcLine({ label, value, def, onChange, ooZero, pad }: { label: string; value: number; def: number; onChange: (n: number) => void; ooZero?: boolean; pad: PadOpen }) {
  const overridden = value !== def && def > 0;
  const z0 = !!ooZero && value === 0 && def > 0;
  return (
    <div className={m.pm}>
      <span className={m.l}>{label}{z0 ? <span className={m.oo0}>подтвердит OO</span> : null}</span>
      <button type="button" className={`${m.v} ${z0 ? m.z0 : overridden ? m.ovr : ""}`}
        onClick={(e) => pad(e.currentTarget, label, value, onChange)}>{rub(value)}</button>
    </div>
  );
}

/* строка метода оплаты: label — значение-пунктир (нулевое тусклое) */
export function PayField({ label, value, onChange, pad, last }: { label: string; value: number; onChange: (v: number) => void; pad: PadOpen; last?: boolean }) {
  return (
    <div className={`${m.pm} ${last ? m.last : ""}`}>
      <span className={m.l}>{label}</span>
      <button type="button" className={`${m.v} ${value ? "" : m.zero}`}
        onClick={(e) => pad(e.currentTarget, label, value, onChange)}>{rub(value)}</button>
    </div>
  );
}

export interface AchItem { id: string; title: string; description: string }

/* Ачивки: строка-тоггл «Ачивки · N из M», развёрнутые — чек + «?» за что даётся */
export function AchPicker({ items, sel, help, open, onOpen, onSel, onHelp }: {
  items: AchItem[]; sel: Set<string>; help: Set<string>; open: boolean;
  onOpen: () => void; onSel: (id: string) => void; onHelp: (id: string) => void;
}) {
  if (items.length === 0) return null;
  return (<>
    <button type="button" className={`${m.sub} ${m.subt}`} onClick={onOpen} aria-expanded={open}>Ачивки · {sel.size} из {items.length}</button>
    {open ? (
      <div className={m.ach}>
        {items.map((a) => (
          <div key={a.id}>
            <div className={`${m.ar} ${sel.has(a.id) ? m.on : ""}`} onClick={() => onSel(a.id)}>
              <span className={m.cb}>{sel.has(a.id) ? "✓" : ""}</span>{a.title}
              {a.description ? <span className={m.q} onClick={(e) => { e.stopPropagation(); onHelp(a.id); }}>{help.has(a.id) ? "▴" : "?"}</span> : null}
            </div>
            {help.has(a.id) && a.description ? <div className={m.arDesc}>{a.description}</div> : null}
          </div>
        ))}
      </div>
    ) : null}
  </>);
}
